import { css } from 'styled-components'

const elevation = (level: number) => css`
  box-shadow: ${props => props.theme.elevations[level]};
`

export default elevation
